import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "immediate-withdrawal",
  "use": "immediate-withdrawal-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"immediate-withdrawal\"><path d=\"M21.125 2.625H3.875a.75.75 0 0 0-.75.75v17.25c0 .415.335.75.75.75h17.25a.75.75 0 0 0 .75-.75V3.375a.75.75 0 0 0-.75-.75ZM20.187 13.5h-7.312v-3h7.313v3Zm0 6.188H4.813V4.313h15.375V9h-8.062a.75.75 0 0 0-.75.75v4.5c0 .415.335.75.75.75h8.063v4.688ZM14.095 12a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol